import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { RoleStore } from './role.store';
import { IRoleState } from 'sustainment-component';

@Injectable({ providedIn: 'root' })
export class RoleQuery extends Query<IRoleState> {
  public constructor(protected store: RoleStore) {
    super(store);
  }
}
